import { SessionConfigDialog } from "@features/session-config/components/SessionConfigDialog";
import { useMemo } from "react";
import { useDialog } from "../DialogContext";
import type { DialogSpec, ShowSessionConfigOptions } from "../types";

const SessionConfigDialogContainer = ({
	options,
	onClose,
}: {
	options: ShowSessionConfigOptions;
	onClose: () => void;
}) => {
	const { showDialog } = useDialog();

	return (
		<SessionConfigDialog
			visible
			handleClose={onClose}
			selectedTagIds={options.selectedTagIds}
			studyRecommendedTopics={options.studyRecommendedTopics}
			preferRecommendedTab={options.preferRecommendedTab}
			onShowPurchase={() =>
				showDialog("purchase", {
					productType: "STUDY_PACK",
					onNavigateBack: () => showDialog("sessionConfig", options),
				})
			}
		/>
	);
};

export const sessionConfigDialog: DialogSpec<"sessionConfig"> = {
	render: ({ options, onClose }) => (
		<SessionConfigDialogContainer options={options} onClose={onClose} />
	),
	getMobileRoute: (options) => ({
		pathname: "/session/customize",
		params: {
			...(options.selectedTagIds?.length
				? { selectedTagIds: options.selectedTagIds.join(",") }
				: {}),
			...(options.studyRecommendedTopics
				? { studyRecommendedTopics: "true" }
				: {}),
			...(options.preferRecommendedTab ? { preferRecommendedTab: "true" } : {}),
		},
	}),
};

export const useSessionConfigDialog = () => {
	const { showDialog, hideDialog } = useDialog();
	return useMemo(
		() => ({
			showSessionConfig: (options: ShowSessionConfigOptions = {}) =>
				showDialog("sessionConfig", options),
			hideSessionConfig: () => hideDialog("sessionConfig"),
		}),
		[showDialog, hideDialog],
	);
};
